module.exports = __webpack_public_path__ + "img/battle.ad380c41.png";